import { useSelector } from 'react-redux';
import { getTimeZone } from '@store/features';
import { useCallback } from 'react';
import moment from 'moment-timezone';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '@constants';

export const useTimezone = () => {
  const timeZone = useSelector(getTimeZone); // Can be "UTC" or an object with `value` and `label`

  // Extract timezone value correctly
  const timeZoneValue =
    typeof timeZone === 'string' ? '' : timeZone?.value.replace('_DST', '').replace('_', '');
  const parts = timeZone?.label.split(' ') ?? []; // Split by space
  parts.shift(); // Remove the first part (UTC+XX:XX)
  if (parts[parts.length - 1] === '(DST)') {
    parts.pop(); // Remove (DST) if present
  }
  const timeZoneLabel = parts.join('_'); // Rejoin with underscores

  const getTimeZoneDisplay = useCallback(
    (dateTime, format = DATE_TIME_FORMAT) => {
      if (!dateTime) return null;
      const formattedDate = moment.utc(dateTime).tz(timeZoneLabel)?.format(format);
      const offset = moment.utc(dateTime).tz(timeZoneLabel)?.format('Z');
      return `${formattedDate} (UTC${offset})`;
    },
    [timeZoneValue, timeZoneLabel]
  );

  const getTimeZoneDateDisplay = useCallback(
    (dateTime, format = DATE_FORMAT) => {
      if (!dateTime) return null;
      const formattedDate = moment.utc(dateTime).tz(timeZoneLabel)?.format(format);
      return `${formattedDate}`;
    },
    [timeZoneValue, timeZoneLabel]
  );

  return { getTimeZoneDisplay, timeZoneValue, getTimeZoneDateDisplay, timeZoneLabel };
};
